import React, { useState, useEffect, createContext } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = (props) => {
  const cc = {};
  return (
    <ThemeContext.Provider value={{ cc: cc }}>
      {props.children}
    </ThemeContext.Provider>
  );
};
